module.exports = __webpack_public_path__ + "static/img/9.27c4c82.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/9.png
// module id = gNDs
// module chunks = 0